import { Link } from "react-router-dom";
import { CiCircleChevLeft } from "react-icons/ci";

const NavbarRoutes = [
  {
    navbarTitle: "Student Dashboard",
    route: "/home",
    backIcon: false,
  },
  {
    navbarTitle: "Internships",
    route: "/internships",
    backIcon: true,
  },
  {
    navbarTitle: "Universities",
    route: "/universities/grid",
    backIcon: true,
  },
  {
    navbarTitle: "Universities",
    route: "/universities/list",
    backIcon: true,
  },
  {
    navbarTitle: "Universities",
    route: "/universities/",
    backIcon: true,
  },
  {
    navbarTitle: "Shortlist",
    route: "/shortlists",
    backIcon: true,
  },
  {
    navbarTitle: "Applications",
    route: "/applications",
    backIcon: true,
  },
  {
    navbarTitle: "Applications",
    route: "/applications/addapplication",
    backIcon: true,
  },
  {
    navbarTitle: "Meetings",
    route: "/meetings/upcoming",
    backIcon: true,
  },
  {
    navbarTitle: "Meetings",
    route: "/meetings/sent",
    backIcon: true,
  },
  {
    navbarTitle: "Meetings",
    route: "/meetings/received",
    backIcon: true,
  },
  {
    navbarTitle: "Add Meeting",
    route: "/meetings/add-meeting",
    backIcon: true,
  },
  {
    navbarTitle: "Reschedule Meeting",
    route: "/meetings/reschedule-meeting",
    backIcon: true,
  },
  {
    navbarTitle: "Essay Grader",
    route: "/essay",
    backIcon: true,
  },
  {
    navbarTitle: "Interactive Learning",
    route: "/interactive-learning",
    backIcon: true,
  },
  {
    navbarTitle: "Chatbot",
    route: "/chatbot",
    backIcon: true,
  },
  {
    navbarTitle: "Notifications",
    route: "/notifications",
    backIcon: true,
  },
  {
    navbarTitle: "User Profile",
    route: "/profile",
    backIcon: true,
  },
  {
    navbarTitle: "Questionnaire",
    route: "/questionnaire/general",
    backIcon: true,
  },
  {
    navbarTitle: "Questionnaire",
    route: "/questionnaire/academics",
    backIcon: true,
  },
  {
    navbarTitle: "Questionnaire",
    route: "/questionnaire/location",
    backIcon: true,
  },
  {
    navbarTitle: "Questionnaire",
    route: "/questionnaire/demographics",
    backIcon: true,
  },
  {
    navbarTitle: "Questionnaire",
    route: "/questionnaire/others",
    backIcon: true,
  },
  {
    navbarTitle: "Settings",
    route: "/settings",
    backIcon: true,
  },
  {
    navbarTitle: "Account Settings",
    route: "/account-settings",
    backIcon: true,
  },
  {
    navbarTitle: "Security Settings",
    route: "/security-settings",
    backIcon: true,
  },
  {
    navbarTitle: "Account Preferences",
    route: "/account-preference",
    backIcon: true,
  },
  {
    navbarTitle: "The UniVision Recommender",
    route: "/recommender",
    backIcon: true,
  },
  {
    navbarTitle: "The UniVision Recommender",
    route: "/recommender/qualifications",
    backIcon: true,
  },
  {
    navbarTitle: "The UniVision Recommender",
    route: "/recommender/preferences",
    backIcon: true,
  },
  {
    navbarTitle: "The UniVision Recommender",
    route: "/recommender/results",
    backIcon: true,
  },
  {
    navbarTitle: "Universities",
    route: "/universities/compare",
    backIcon: true,
  },
  {
    navbarTitle: "The UniVision Recommender",
    route: "/recommender/compare",
    backIcon: true,
  },
  {
    navbarTitle: "Visa Information",
    route: "/visa-information",
    backIcon: true,
  },
  {
    navbarTitle: "Profile Builder",
    route: "/profile-builder",
    backIcon: true,
  },
  {
    navbarTitle: (
      <div className="flex gap-3 items-center">
        <Link to="/profile-builder">
          <CiCircleChevLeft className="navbar-back-icon" />
        </Link>
        Profile Builder
      </div>
    ),
    route: "/profile-builder/",
    backIcon: false,
  },
  {
    navbarTitle: "Explore",
    route: "/explore",
    backIcon: true,
  },
  {
    navbarTitle: "Explore",
    route: "/explore/results",
    backIcon: true,
  },
  {
    navbarTitle: "Support",
    route: "/support",
    backIcon: true,
  },
];
export default NavbarRoutes;
